// ref: https://github.com/jfcere/ngx-markdown/issues/461#issuecomment-2798755506
import { Tokens } from 'marked';
const inlineRule = /^(\${1})(?!\$)((?:\\.|[^\\])*?(?:\\.|[^\\$]))\1(?=[\s\-;)?!.,:？！。，：]|$)/;

const blockRule = /^(\${2})\n?((?:\\[^]|[^\\])+?)\n?\1/;

export const mathExtensions = [
  // Display math ($$...$$)
  {
    name: 'mathDisplay',
    level: 'block',
    start(src: string) {
      return src.indexOf('$$');
    },
    tokenizer(src: string) {
      const match = src.match(blockRule);
      if (match) {
        return {
          type: 'mathDisplay',
          raw: match[0],
          text: match[2].trim(), // we use only this value in the renderer, consider removing the rest
          displayMode: match[1].length === 2,
        };
      }
      return undefined;
    },
    renderer(token: Tokens.Generic) {
      return `\n$$${token['text']}$$\n`;
    },
  },

  // Inline math ($...$)
  {
    name: 'mathInline',
    level: 'inline',
    start(src: string) {
      let index;
      let indexSrc = src;

      while (indexSrc) {
        index = indexSrc.indexOf('$');
        if (index === -1) {
          return;
        }
        const f = index === 0 || [' ', '('].includes(indexSrc.charAt(index - 1));
        if (f) {
          const possibleKatex = indexSrc.substring(index);

          if (possibleKatex.match(inlineRule)) {
            return index;
          }
        }

        indexSrc = indexSrc.substring(index + 1).replace(/^\$+/, '');
      }
      return -1;
    },
    tokenizer(src: string) {
      const match = src.match(inlineRule);
      if (match) {
        return {
          type: 'mathInline',
          raw: match[0],
          text: match[2].trim(), // we use only this value in the renderer, consider removing the rest
          displayMode: match[1].length === 2,
        };
      }
      return undefined;
    },
    renderer(token: Tokens.Generic) {
      return `$${token['text']}$`;
    },
  },
];
